export default "__VITE_ASSET__C$KkTjWQ__"